import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AcknowledgementPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Acknowledgement</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <br />
            <p style={{ fontSize: "1.2em" }}>
              We thank Dr. Bharath Settur for advice on field data collection.
              Field research is funded by the EIACP (ENVIS) division, the
              Ministry of Environment, Forests and Climate Change, Government of
              India (grant: SP/DEOO-22 001), and infrastructure support is
              provided by the Indian Institute of Science.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AcknowledgementPage;
